import palette from '@lib/core/src/theme/palette';
import {
  InputBase,
  Stack,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography
} from '@mui/material';

export const Container = styled(Stack)({
  justifyContent: 'center',
  padding: '12px 0px',
  gap: '8px',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  borderBottom: `2px solid ${palette.grey[300]}`,
  '&:hover': {
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.01) 0%, rgba(0, 0, 0, 0.01) 100%, ${palette.white})`
  }
});

export const Content = styled(Stack)({
  padding: '0px 12px',
  gap: '8px',
  alignItems: 'flex-start',
  width: '100%'
});

export const TaskTitle = styled(InputBase)(() => ({
  padding: '0px 5px',
  fontWeight: 500,
  border: 'none',
  fontSize: '13px',
  width: '100%',
  '& .MuiInputBase-input': {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  ':focus-within': {
    borderRadius: '8px',
    cursor: 'default',
    border: `1px solid ${palette.border.grey}`,
    backgroundColor: palette.white
  }
}));

export const TaskActions = styled(Stack)({
  gap: '8px',
  flexDirection: 'row',
  alignItems: 'center'
});

export const ActionButton = styled(Stack)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  gap: '6px',
  justifyContent: 'center',
  alignItems: 'center',
  height: '24px',
  padding: '8px 12px',
  borderRadius: '12px',
  backgroundColor: palette.grey[100],
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? 'none' : 'auto',

  '&:hover': disabled
    ? {}
    : {
        backgroundColor: palette.grey[200]
      }
}));

export const TaskActionTitle = styled(Typography)({
  color: palette.grey[500],
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px'
});

export const TaskActionDisbaledTitle = styled(Stack)({
  color: palette.grey[400],
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px'
});

export const DismissButton = styled(Stack)({
  gap: '6px',
  padding: '5px',
  borderRadius: '12px',
  alignItems: 'center',
  flexDirection: 'row',
  cursor: 'pointer',
  ':hover': { backgroundColor: palette.grey[200] }
});

export const SourceTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  maxWidth: '350px',
  boxShadow: '0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08)',
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
    backgroundColor: palette.black,
    padding: '8px'
  }
});
